export default __webpack_public_path__ + "static/media/small@2x.f611afaa.png";